import { Link } from "react-router-dom";

const TatapMuka = () => {
  return (
    <div className="TatapMuka-Container">
      <p className="TatapMuka-Title">Pelatihan Tatap Muka</p>

      <div className="TatapMuka-Card">
        <img
          className="ImgTatapMuka"
          src="http://via.placeholder.com/200x270"
          alt="banner kelas tatap muka 1"
        />
        <div className="IsiBannerTatapMuka">
          <p className="tatapMukaCard-title">Digital Marketing</p>
          <p className="tatapMukaCard-text">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book.{" "}
          </p>
          <div className="Detail-Button-Container">
            <table className="tatapMukaTable">
              <tr>
                <td>Tanggal</td>
                <td> :</td>
                <td>Jumat, 22 April 2022</td>
              </tr>
              <tr>
                <td>Jam</td>
                <td>:</td>
                <td>10:00 WIB</td>
              </tr>
              <tr>
                <td>Tempat</td>
                <td> :</td>
                <td>Kampusu Bina Nusantara Bandung</td>
              </tr>
              <tr>
                <td>Kapasitas</td>
                <td> :</td>
                <td>100 Orang</td>
              </tr>

              <tr>
                <td>Pembicara</td>
                <td> :</td>
                <td>kenny melvern</td>
              </tr>
            </table>
            <Link to="/DigitalMarketing">
              <button>Daftar</button>
            </Link>
          </div>
        </div>
      </div>

      <div className="TatapMuka-Card">
        <img
          className="ImgTatapMuka"
          src="http://via.placeholder.com/200x270"
          alt="banner kelas tatap muka 1"
        />
        <div className="IsiBannerTatapMuka">
          <p className="tatapMukaCard-title">Digital Marketing</p>
          <p className="tatapMukaCard-text">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book.{" "}
          </p>
          <div className="Detail-Button-Container">
            <table className="tatapMukaTable">
              <tr>
                <td>Tanggal</td>
                <td> :</td>
                <td>Jumat, 22 April 2022</td>
              </tr>
              <tr>
                <td>Jam</td>
                <td>:</td>
                <td>14:00 WIB</td>
              </tr>
              <tr>
                <td>Tempat</td>
                <td> :</td>
                <td>Kampus Bina Nusantara Anggrek</td>
              </tr>
              <tr>
                <td>Kapasitas</td>
                <td> :</td>
                <td>100 Orang</td>
              </tr>

              <tr>
                <td>Pembicara</td>
                <td> :</td>
                <td>kenny melvern</td>
              </tr>
            </table>
            <Link to="/DigitalMarketing">
              <button>Daftar</button>
            </Link>
          </div>
        </div>
      </div>

      <div className="TatapMuka-Card">
        <img
          className="ImgTatapMuka"
          src="http://via.placeholder.com/200x270"
          alt="banner kelas tatap muka 1"
        />
        <div className="IsiBannerTatapMuka">
          <p className="tatapMukaCard-title">Digital Marketing</p>
          <p className="tatapMukaCard-text">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book.{" "}
          </p>
          <div className="Detail-Button-Container">
            <table className="tatapMukaTable">
              <tr>
                <td>Tanggal</td>
                <td> :</td>
                <td>Jumat, 22 April 2022</td>
              </tr>
              <tr>
                <td>Jam</td>
                <td>:</td>
                <td>08:00 WIB</td>
              </tr>
              <tr>
                <td>Tempat</td>
                <td> :</td>
                <td>Kampus Bina Nusantara Malang</td>
              </tr>
              <tr>
                <td>Kapasitas</td>
                <td> :</td>
                <td>100 Orang</td>
              </tr>

              <tr>
                <td>Pembicara</td>
                <td> :</td>
                <td>kenny melvern</td>
              </tr>
            </table>
            <Link to="/DigitalMarketing">
              <button>Daftar</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TatapMuka;
